<template>
    <cadastro-simples-form
        endpoint="intervencao-pedagogica"
        rota-base="/admin/intervencao-pedagogica"
        titulo-singular="Intervenção Pedagógica"
        :campos-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
